import "promise-polyfill/src/polyfill";
import { bugsnagClient } from "~/plugins";
import Vue from "vue";
import bugsnagVue from "@bugsnag/plugin-vue";
import VueSocialSharing from "vue-social-sharing";
bugsnagClient.use(bugsnagVue, Vue);

import store from "~/store";
import router from "~/router";
import { i18n } from "~/plugins";
import App from "~/components/App";
import "~/components";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import boost from "highcharts/modules/boost";
import exportingInit from "highcharts/modules/exporting";
import VueIntercom from "vue-intercom";
import {
  roundCryptoPrice,
  roundEstimate,
  roundMarketFractionalValue,
  roundOverviewDepositValue,
  roundNumber,
  roundQuantity,
  parseScientific
} from "./plugins/calculation";

// higcharts requires moment.js on the window object for timezone offset
window.moment = moment;
Highcharts.setOptions({
  time: {
    timezone: moment.tz.guess()
  }
});

exportingInit(Highcharts);
stockInit(Highcharts);
Vue.use(HighchartsVue);
boost(Highcharts);

Vue.filter("formatDate", function(value, format) {
  if (value) {
    return moment
      .utc(String(value))
      .tz(moment.tz.guess())
      .format(format ? format : "DD-MMM-YYYY HH:mm:ss");
  }
});

Vue.filter("formatDateAgo", function(value) {
  if (value) {
    var date = moment.utc(String(value)).tz(moment.tz.guess());
    if (moment().diff(date, "h") < 24) {
      return moment
        .utc(String(value))
        .tz(moment.tz.guess())
        .format("HH:mm");
    } else {
      return moment
        .utc(String(value))
        .tz(moment.tz.guess())
        .fromNow();
    }
  }
});

Vue.filter("isValidDate", function(value) {
  if (value) {
    var m = moment(value);
    return m.isValid();
  }
  return false;
});

Vue.filter("formatDateTS", function(value, format) {
  if (value) {
    return moment
      .utc(new Date(value * 1000).toUTCString())
      .tz(moment.tz.guess())
      .format(format ? format : "DD-MMM-YYYY HH:mm:ss");
  }
});

Vue.filter("toETHFormat", function(value) {
  if (value) {
    return value / 1000000000000000000;
  }
});

Vue.filter("roundCryptoPrice", function(value, scale = 6) {
  return roundCryptoPrice(value, scale);
});

Vue.filter("roundEstimatesAccountValue", function(value) {
  if (value === 0) {
    return 0;
  }

  if (value >= 100) {
    return roundNumber(value, 0);
  } else if (value < 100 && value >= 10) {
    return roundNumber(value, 1);
  } else if (value < 10 && value >= 1) {
    return roundNumber(value, 2);
  } else if (value < 1) {
    return roundEstimate(value, 6);
  }

  return roundNumber(value, 6);
});

Vue.filter("roundMarketsFractionalAccountValue", function(value) {
  if (value === 0) {
    return 0;
  }

  if (value >= 1000) {
    return roundNumber(value, 0);
  } else if (value < 1000 && value >= 100) {
    return roundNumber(value, 1);
  } else if (value < 100 && value >= 10) {
    return roundNumber(value, 2);
  } else if (value < 10 && value >= 1) {
    return roundNumber(value, 3);
  } else if (value < 1) {
    return roundMarketFractionalValue(value, 6);
  }

  return roundNumber(value, 6);
});

Vue.filter("roundOverviewDepositsValue", function(value) {
  if (value === 0) {
    return 0;
  }

  if (value >= 1000) {
    return roundNumber(value, 0);
  } else if (value < 1000 && value >= 100) {
    return roundNumber(value, 1);
  } else if (value < 100 && value >= 10) {
    return roundNumber(value, 2);
  } else if (value < 10 && value >= 1) {
    return roundNumber(value, 3);
  } else if (value < 1) {
    return roundOverviewDepositValue(value, 8);
  }

  return roundNumber(value, 8);
});

Vue.filter("roundQuantity", function(value, scale = 0) {
  return roundQuantity(value, scale);
});

Vue.filter("roundNumber", function(value, scale = 2) {
  return roundNumber(value, scale);
});

Vue.filter("parseScientific", function(value) {
  return parseScientific(value);
});

Vue.filter("formatAge", function(value) {
  if (value) {
    return moment
      .utc(String(value))
      .tz(moment.tz.guess())
      .fromNow();
  }
});

Vue.filter("truncate", function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length
    ? content.slice(0, length).trim() + clamp
    : content;
});

Vue.use(Vuetify, {
  theme: {
    primary: "#2B4889",
    secondary: "#5076B8",
    accent: "#7090C0",
    error: "#DB4A36",
    warning: "#C8B15D",
    info: "#239AAD",
    success: "#2F9997",
    tab_bg_color: "#E6EFFF",
    tab_selected_color: "#103A84",
    highcharts_sell_color: "#3455ce",
    highcharts_sell_no_surplus_color: "#FFC929",
    highcharts_buy_color: "#7EC171"
  }
});

Vue.use(VueIntercom, { appId: "akd7go7w" });
Vue.config.productionTip = false;

Vue.use(VueSocialSharing);

const app = new Vue({
  i18n,
  store,
  router,
  ...App
});

export default app;



// WEBPACK FOOTER //
// ./resources/js/app.js